export const nurtureCampaignQueryKeys = {
  _base: () => ["nurtureCampaigns"],
  all: (agencyId: string) => [
    ...nurtureCampaignQueryKeys._base(),
    { agencyId },
  ],
  single: (agencyId: string, campaignId: string) => [
    ...nurtureCampaignQueryKeys.all(agencyId),
    { campaignId },
  ],
  statistics: (agencyId: string, campaignId: string) => [
    ...nurtureCampaignQueryKeys.single(agencyId, campaignId),
    "statistics",
  ],
  recipients: (agencyId: string, campaignId: string) => [
    ...nurtureCampaignQueryKeys.single(agencyId, campaignId),
    "recipients",
  ],
};
